import { render, staticRenderFns } from "./PaidOrder.vue?vue&type=template&id=2cb24254&scoped=true&"
import script from "./PaidOrder.vue?vue&type=script&lang=js&"
export * from "./PaidOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb24254",
  null
  
)

component.options.__file = "PaidOrder.vue"
export default component.exports